// @flow
import _ from 'lodash';
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import { getInvitableUsers, callUser, timedoutCall } from 'common/helpers/api';
import { updateCallStatus, updateCallee, updateCallableUsers, } from '../../../../call';
import Tooltip from 'jitsi/base/tooltip/components/Tooltip';
import { translate } from 'jitsi/base/i18n/functions';
import { IconCloseLarge } from 'jitsi/base/icons/svg';
import { SearchInput } from 'common/components/SearchInput';
import { IISightIcon } from 'common/components/IISightIcon';
import { makeStyles } from 'tss-react/mui';
import { withPixelLineHeight } from 'jitsi/base/styles/functions.web';
import Button from 'jitsi/base/ui/components/web/Button';
import { BUTTON_TYPES } from 'jitsi/base/ui/constants.any';
import Input from 'jitsi/base/ui/components/web/Input';
import { hideDialog } from 'jitsi/base/dialog/actions';
import AddPeopleDialog from 'jitsi/invite/components/add-people-dialog/web/AddPeopleDialog';
const useStyles = makeStyles()((theme) => ({
    user: {
        paddingBlock: theme.spacing(1),
        marginBlock: theme.spacing(3),
        borderRadius: theme.shape.borderRadius,
        position: 'relative',
        "&:last-of-type": {
            marginBottom: 0
        }
    },
    closeIcon: {
        marginBottom: 20,
    },
    userInfoContainer: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        zIndex: 2,
    },
    picture: {
        ...withPixelLineHeight(theme.typography.heading4),
        backgroundColor: theme.palette.iisightBrandBackground,
        height: 45,
        width: 45,
        position: 'relative',
        marginRight: theme.spacing(2),
        borderRadius: theme.shape.circleRadius,
        '& img': {
            borderRadius: theme.shape.circleRadius,
            objectFit: 'cover',
        },
    },
    textInfo: {
        ...withPixelLineHeight(theme.typography.bodyShortRegular),
        color: theme.palette.iisightGray900,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    name: {
        fontWeight: 700,
    },
    orgName: {
        color: theme.palette.iisightGray700,
    },
    status: {
        width: 11,
        height: 11,
        position: 'absolute',
        bottom: 0,
        right: 0,
        backgroundColor: theme.palette.iisightGray400,
        borderRadius: theme.shape.circleRadius,
        border: `1px solid ${theme.palette.iisightWhite}`,
        '.available &': {
            backgroundColor: theme.palette.iisightBrandBackground,
        },
    },
    customInvitationMessage: {
        zIndex: 2,
        position: "relative",
        display: 'flex',
        marginTop: theme.spacing(3),
    },
    messageInput: {
        flex: 1,
        marginRight: theme.spacing(2),
        '& input': {
            color: theme.palette.iisightDefaultText,
            backgroundColor: `${theme.palette.iisightGray100}`,
            border: `1px solid ${theme.palette.iisightGray400}`,
        },
    },
    actionsContainer: {
        marginLeft: 'auto',
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        right: 0,
        backgroundColor: theme.palette.iisightWhite,
        paddingLeft: theme.spacing(2),
    },
    cancelButton: {
        padding: 0,
        marginRight: theme.spacing(2),
        color: theme.palette.iisightBlue500,
        '&:hover': {
            color: theme.palette.iisightBlue700,
            background: 'inherit',
        },
        '&:active': {
            color: theme.palette.iisightBlue900,
            background: 'inherit',
        },
    },
}));
function CallUserTab({ t, callee, status, organizations, isListenerAdded }) {
    const dispatch = useDispatch();
    const { classes, cx } = useStyles();
    const [loading, setLoading] = useState(true);
    const [selectedUser, setSelectedUser] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [messageText, setMessageText] = useState('');
    const [showMessageBar, setShowMessageBar] = useState(false);
    useEffect(() => {
        (async () => {
            const token = localStorage.getItem('11S_TOKEN');
            const { data } = await getInvitableUsers(token);
            if (data?.data)
                dispatch(updateCallableUsers(data.data.orgs));
            setLoading(false);
        })();
    }, []);
    //   const handler = (msg) => {
    //     try {
    //       const jsonMessage = $(msg).find('>json-message').text();
    //       const parsedJson = JSON.parse(jsonMessage);
    //       if (parsedJson.call_status) {
    //         dispatch(updateCallStatus(parsedJson.call_status));
    //       }
    //     } catch (e) {
    //       return true;
    //     }
    //     return true;
    //   };
    //   useEffect(() => {
    //     reachCalls();
    //     if (!isListenerAdded) {
    //       dispatch(updateIsListenerAdded(true));
    //       window.APP.connection.xmpp.connection._stropheConn.addHandler(
    //         handler,
    //         null,
    //         'message',
    //         null,
    //         null,
    //       );
    //     }
    //   }, []);
    const startCallUser = useCallback(async () => {
        if (!selectedUser)
            return;
        dispatch(hideDialog(AddPeopleDialog));
        await dispatch(updateCallStatus('preparing', selectedUser));
        await dispatch(updateCallee(selectedUser));
        try {
            const original_call_id = window.APP.room.vconnect ? window.APP.room?.call?.id : null;
            const { status, data } = await callUser(selectedUser.id, APP.room.id, original_call_id, messageText);
            if (status === 200) {
                const { call_id, temporary_token } = data.data;
                await dispatch(updateCallStatus('ringing', selectedUser));
                await dispatch(updateCallee({ ...selectedUser, callId: call_id, temporaryToken: temporary_token }));
                setTimeout(() => {
                    let { callee, status } = APP.store.getState()['features/call'];
                    if (callee.id === selectedUser.id && status === 'ringing') {
                        dispatch(updateCallStatus('timedout', selectedUser));
                        timedoutCall(callee.callId, callee.temporaryToken);
                    }
                }, 15000);
            }
            else {
                dispatch(updateCallStatus('error'));
            }
        }
        catch (err) {
            dispatch(updateCallStatus('error'));
        }
        finally {
            setSelectedUser(null);
            setMessageText('');
            setShowMessageBar(false);
        }
    }, [selectedUser, messageText]);
    const inviteList = useMemo(() => {
        const list = [];
        if (organizations) {
            organizations.forEach((element) => {
                const usersOfOrg = _.uniqBy(element.users, 'id').filter((u) => u.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1);
                if (usersOfOrg.length > 0) {
                    list.push({
                        id: element.id,
                        name: element.name,
                        users: usersOfOrg,
                    });
                }
            });
        }
        return list;
    }, [organizations, searchText]);
    const selectUser = useCallback((user) => {
        if (user.id === selectedUser?.id)
            return;
        setShowMessageBar(false);
        setMessageText('');
        setSelectedUser(user);
    }, [selectedUser]);
    return (React.createElement("div", null,
        React.createElement(SearchInput, { autoFocus: true, id: 'call-user-search-box', onChange: setSearchText, placeholder: t('participantsPane.search'), value: searchText }),
        inviteList.length === 0 && React.createElement("div", { style: { marginTop: '10px' } }, "No result."),
        inviteList.map((org) => (React.createElement("div", { key: org.id, style: { marginTop: '10px' } },
            org.name,
            React.createElement("hr", null),
            org.users.map((user) => (React.createElement("div", { className: cx(classes.user, user.available && 'available', selectedUser?.id === user.id && 'selected-user'), key: user.id, onClick: () => selectUser(user) },
                React.createElement("div", { className: classes.userInfoContainer },
                    React.createElement(Tooltip, { content: user.available ? 'Available' : 'Unavailable', position: 'right' },
                        React.createElement("div", { className: classes.picture },
                            user.pic ? (React.createElement("img", { src: user.pic, height: '45', width: '45' })) : (React.createElement("svg", { height: '45', viewBox: '0 0 100 100', width: '45', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
                                React.createElement("text", { dominantBaseline: 'central', fill: 'rgba(255,255,255,.9)', fontSize: '40pt', textAnchor: 'middle', x: '50', y: '50' }, user.name[0].toUpperCase()))),
                            React.createElement("div", { className: classes.status }))),
                    React.createElement("div", { className: classes.textInfo },
                        React.createElement("span", { className: classes.name }, user.name),
                        React.createElement("span", { className: classes.orgName }, org.name)),
                    selectedUser?.id === user.id && user.available && (React.createElement("div", { className: classes.actionsContainer }, showMessageBar ? (React.createElement(IISightIcon, { className: classes.closeIcon, accessibilityLabel: t('dialog.accessibilityLabel.close'), icon: IconCloseLarge, id: 'close-custom-invite-message', onClick: () => {
                            setMessageText('');
                            setShowMessageBar(false);
                        } })) : (React.createElement(React.Fragment, null,
                        React.createElement(Button, { className: classes.cancelButton, labelKey: 'callUser.sendMessage', type: BUTTON_TYPES.TERTIARY, onClick: () => setShowMessageBar(true) }),
                        React.createElement(Button, { labelKey: 'callUser.invite', id: 'call-button', disabled: !user.available || (window.APP.room?.room_type != 4 && callee != null), onClick: startCallUser })))))),
                selectedUser?.id === user.id && showMessageBar && (React.createElement("div", { className: classes.customInvitationMessage },
                    React.createElement(Input, { autoFocus: true, id: 'custom-invite-message-input', className: classes.messageInput, onChange: setMessageText, placeholder: 'Enter Message', value: messageText }),
                    React.createElement(Button, { id: 'custom-message-invite-send-button', onClick: startCallUser, labelKey: 'callUser.invite', disabled: !user.available || (window.APP.room?.room_type != 4 && callee != null) })))))))))));
}
/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code ShareMeeting} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function mapStateToProps(state) {
    return state['features/call'];
}
// /**
//  * Maps dispatching of some action to React component props.
//  *
//  * @param {Function} dispatch - Redux action dispatcher.
//  * @returns {Props}
//  */
// const mapDispatchToProps = {};
export default translate(connect(mapStateToProps)(CallUserTab));
